"use strict";

module.exports = require("./ConsoleAdapter");